import React from "react";
import { Component } from "react";

import { Container, Card } from "react-bootstrap";

class Footer extends Component {
    render() {
        return (
        <div>
            <Container>
    <Card>
        <Card.Body>
       
        <Card.Title><p>Synthetic Osculations</p></Card.Title>
       <Card.Text>
       <p>Osculation:
1.-The act of kissing.
2.-A kiss.
3.-A contact, as between two curves or surfaces, at three or more common points.</p> 
        
       
<p>Concept and programming by <a target="_blank" rel="noreferrer" href="https://marlonbarrios.github.io/">Marlon Barrios Solano</a></p>
<p><a target="_blank" rel="noreferrer" href="https://www.patreon.com/user?u=84024387">Support R&D and help with the costs of OpenAI</a></p>
<p>Powered by <a target="_blank" rel="noreferrer" href=" https://beta.openai.com/overview">OpenAI</a></p>
            </Card.Text>
        </Card.Body>
    </Card>
</Container>
        </div>
        );
    }
    }
export default Footer;
